import styled from "@emotion/styled/macro";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const Container = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 1em 2em;
    text-align: center;
    flex-direction: column;
  }
  margin: 4em 0;
  display: flex;
  box-shadow: 0px 0px 19px -11px ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.white};
  border: 10px solid ${({ theme }) => theme.colors.brown};
`;
const Unavailble = ({ text }) => {
  return (
    <Container>
      <ReactMarkdown rehypePlugins={[rehypeRaw]} children={text} />
    </Container>
  );
};

export default Unavailble;
